import http from 'helpers/http';

import type { IContactForm } from 'models/Contact';

export const serviceContact = {
  sendMessage: (message: IContactForm) => http.post('/contact', message),
};
